var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNewsroom = function SvgNewsroom(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 36.9997C48 37.552 47.5523 37.9997 47 37.9997H3C2.44772 37.9997 2 37.552 2 36.9997V31.9998H48V36.9997Z",
    fill: "#FFE0E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0H47C48.6561 0.00176371 49.9982 1.34388 50 3V37C49.9982 38.6561 48.6561 39.9982 47 40H30.4L31.6 46H35C35.5523 46 36 46.4477 36 47C36 47.5523 35.5523 48 35 48H15C14.4477 48 14 47.5523 14 47C14 46.4477 14.4477 46 15 46H18.4L19.6 40H3C1.34388 39.9982 0.00176371 38.6561 0 37V3C0.00176371 1.34388 1.34388 0.00176371 3 0ZM20.4401 46H29.5601L28.3601 40H21.6401L20.4401 46ZM47.9999 36.9997C47.9999 37.552 47.5522 37.9997 46.9999 37.9997H2.99994C2.44765 37.9997 1.99994 37.552 1.99994 36.9997V31.9998H47.9999V36.9997ZM1.99994 29.9998H47.9999V2.99975C47.9999 2.44747 47.5522 1.99975 46.9999 1.99975H2.99994C2.44765 1.99975 1.99994 2.44747 1.99994 2.99975V29.9998Z",
    fill: "#FC628F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 25.9998H22C23.1046 25.9998 24 25.1043 24 23.9998V13.9998C24 12.8952 23.1046 11.9998 22 11.9998H10C8.89543 11.9998 8 12.8952 8 13.9998V23.9998C8 25.1043 8.89543 25.9998 10 25.9998ZM9.99993 13.9995H21.9999V23.9995H9.99993V13.9995Z",
    fill: "#FC628F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 11.9998H29C28.4477 11.9998 28 12.4475 28 12.9998C28 13.552 28.4477 13.9998 29 13.9998H41C41.5523 13.9998 42 13.552 42 12.9998C42 12.4475 41.5523 11.9998 41 11.9998Z",
    fill: "#FC628F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2857 5.99951H8.71429C8.3198 5.99951 8 6.44723 8 6.99951C8 7.5518 8.3198 7.99951 8.71429 7.99951H17.2857C17.6802 7.99951 18 7.5518 18 6.99951C18 6.44723 17.6802 5.99951 17.2857 5.99951Z",
    fill: "#FC628F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 18.0002H29C28.4477 18.0002 28 18.448 28 19.0002C28 19.5525 28.4477 20.0002 29 20.0002H41C41.5523 20.0002 42 19.5525 42 19.0002C42 18.448 41.5523 18.0002 41 18.0002Z",
    fill: "#FC628F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 24.0005H29C28.4477 24.0005 28 24.4482 28 25.0005C28 25.5528 28.4477 26.0005 29 26.0005H41C41.5523 26.0005 42 25.5528 42 25.0005C42 24.4482 41.5523 24.0005 41 24.0005Z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNewsroom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/newsroom.399ee6b3140533a34065b750db2e9e59.svg";